export default __webpack_public_path__ + "static/media/store.3a7a12e1.png";